import TableTotal from './TableTotal';
import Tooltip from '../../components/Tooltip';
import styles from './Table.module.scss';

interface TableDataRow {
  [key: string]: any;
  email?: string;
  userId?: string;
}

interface Props {
  tableData: any;
  columns: {
    label: string;
    accessor: string;
    sortable: boolean;
    tooltip?: string;
    renderTooltip?: (data: TableDataRow) => string | null;
    clickable?: boolean | ((data: TableDataRow) => boolean);
    onClick?: (data: TableDataRow) => void;
  }[];
  totals?: [];
}
const TableBody = ({ tableData, columns, totals }: Props) => {
  return (
    <tbody>
      {tableData.map((data: any, i: any) => {
        return (
          <tr key={`${data[0]}-${i}`}>
            {columns.map(({ accessor, renderTooltip, clickable, onClick }) => {
              const tData = data[accessor] ? data[accessor] : '0';
              const tooltipContent = renderTooltip ? renderTooltip(data) : null;
              const isClickable = typeof clickable === 'function' ? clickable(data) : clickable;

              if (isClickable && onClick) {
                const content = (
                  <span className={styles.clickable} onClick={() => onClick(data)}>
                    {tData}
                  </span>
                );

                if (tooltipContent) {
                  return (
                    <td key={accessor}>
                      <Tooltip content={tooltipContent} direction='bottom' color='blue'>
                        {content}
                      </Tooltip>
                    </td>
                  );
                }

                return <td key={accessor}>{content}</td>;
              }

              if (tooltipContent) {
                return (
                  <td key={accessor}>
                    <Tooltip content={tooltipContent} direction='bottom' color='blue'>
                      <span
                        onMouseEnter={() => {
                          console.log(`${tData}: ${tooltipContent}`);
                        }}
                      >
                        {tData}
                      </span>
                    </Tooltip>
                  </td>
                );
              }

              return <td key={accessor}>{tData}</td>;
            })}
          </tr>
        );
      })}
      {totals && <TableTotal totals={totals} />}
    </tbody>
  );
};

export default TableBody;
